// Per-line tax code written by the backend when the JKDM non-citizen rule exempts a line.
const TAX_EXEMPT_CODE = 'TAX_EXEMPT';

(() => {
  angular.module('app').component('commonPatientTicketsDetailGeneralTreatment', {
    templateUrl: require('./widget.html'),
    controller: GeneralTreatmentWidgetController,
    controllerAs: 'vm',
    bindings: {
      ticket: '<',
      hasGpTicketEnhancement: '<'
    },
  });

  GeneralTreatmentWidgetController.$inject = [
    '$filter',
    'Hms.PatientTickets.PatientTicketType',
    'Hms.MultiTenancy.TenantClinicType',
    'Hms.PatientTickets.PatientTicketFormat',
    'Hms.PatientTickets.TreatmentType',
    'Hms.Services.ServiceType',
  ];

  function GeneralTreatmentWidgetController(
    $filter,
    enumPatientTicketType,
    enumTenantClinicType,
    enumPatientTicketFormat,
    enumPatientTicketTreatmentType,
    enumServiceType
  ) {
    const vm = this;

    const unitValueFilter = $filter('unitValue');
    const frequencyUnitValueFilter = $filter('frequencyUnitValue');

    vm.isHost = App.isHost();
    vm.isHealthScreeningTicket = vm.ticket.serviceType === 9;
    vm.isPharmacyTicket = vm.ticket.serviceType === 6;
    vm.hasGpTicketEnhancement = abp.setting.getBoolean(
        'Hms.Feature.GPTicketEnhancement'
    );

    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');

    vm.enums = {
      patientTicketType: enumPatientTicketType,
      tenantClinicType: enumTenantClinicType,
      patientTicketFormat: enumPatientTicketFormat,
      patientTicketTreatmentTypes: enumPatientTicketTreatmentType,
      serviceType: enumServiceType
    };
            
    vm.treatmentTypes = vm.enums.patientTicketTreatmentTypes.values;

    vm.isViewGrossTaxColumns = vm.hasGpTicketEnhancement
      && vm.ticket.version === 'V2'
      && vm.ticket.serviceType === vm.enums.serviceType.GP.id;

    vm.$onChanges = $onChanges;

    function $onChanges(changes) {
      // If ticket is using new format GP ticket,
      // populate treatments to include prescriptions.

      if (
        changes.ticket &&
        changes.ticket.currentValue &&
        vm.ticket.serviceType === 1 &&
        vm.ticket.ticketFormat === 1
      ) {
        renderTreatmentWithPrescription();
      }
    }

    function renderTreatmentWithPrescription() {
      _.each(vm.ticket.treatments, (treatment) => {
        const t = treatment;
        const result = _.chain(t.prescriptions)
          .map((k) => ({
            name: k.name,
            quantity: k.quantity ? unitValueFilter(k.quantity) : null,
            amount: k.amount,
            strength: k.strength ? k.strength.value : null,
            strengthUnit: k.strength ? k.strength.unit : null,
            dosage: getDosageAsString(k.dosage, k.dosageFrequency),
            treatmentType: k.treatmentType
          }))
          .value();

        t.prescriptions = result;
      });
      
      calculateAmounts();
    }

    function getDosageAsString(dosage, dosageFrequency) {
      let tokens = [unitValueFilter(dosage), frequencyUnitValueFilter(dosageFrequency)];
      tokens = _.filter(tokens, (t) => t);

      if (tokens.length) return tokens.join(', ');
      return '-';
    }

    function calculateAmounts() {
      const taxRate = ((vm.ticket.taxPercentage || 0) / 100) + 1;

      _.each(vm.ticket.treatments, (x) => {
        // A line the backend stored as exempt carries no tax, whatever the header rate says.
        // Reading the stored code keeps this table agreeing with the database and the printout
        // (HM-11189); on a ticket with no exempt line nothing changes.
        const isExemptLine = x.taxCode === TAX_EXEMPT_CODE;

        _.each(x.prescriptions, (prescription) => {
          if (prescription.amount == null) {
            prescription.grossAmount = null;
            prescription.taxAmount = null;
          } else if (prescription.amount > 0) {
            if (isExemptLine) {
              prescription.grossAmount = App.evenRound(prescription.amount, 2);
              prescription.taxAmount = App.evenRound(0, 2);
            } else if (vm.ticket.taxPercentage > 0) {
              prescription.grossAmount = App.evenRound(prescription.amount/taxRate, 2);
              prescription.taxAmount =
                App.evenRound(prescription.amount - prescription.grossAmount, 2);
            } else {
              prescription.grossAmount = App.evenRound(prescription.amount, 2);
              prescription.taxAmount = App.evenRound(0, 2);
            }
          }
        });
      });
    }

  }
})();
